const actions = {
  SET_STATE: "menu/SET_STATE",
  GET_DATA: "menu/GET_DATA",
  UPDATE: "menu/UPDATE",
}

export default actions
